'use client';

import React from 'react';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { TacSdkProvider } from './tac-sdk';
import { ENVS } from '@/constants/config';
import { isLocal } from '@/utils/common';

const manifestUrl = isLocal ? 'https://claim.tokentable.xyz/manifest.json' : `${window.location.origin}/manifest.json`;

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <TonConnectUIProvider manifestUrl={manifestUrl}>
      <TacSdkProvider network={ENVS.TAC_NETWORK}>{children}</TacSdkProvider>
    </TonConnectUIProvider>
  );
}
